import React, { useState, useEffect } from "react"
import styled from "styled-components"
import Lottie from "react-lottie"
import { Row, Col, Card, InputGroup, FormControl } from "react-bootstrap"
import Image from "gatsby-image"
import Inscription from "../CleverMeets/OnlyInput"
import Data from "../../../meets/anim/404_animation.json"

import Parser from "html-react-parser"

export let ImgPortada = props => {
  const animation = require(`../../../meets/anim/${props.anim}`)
  const defaultOptions = {
    loop: true,
    renderer: "svg",
    autoplay: true,
    id: "lottie",
    className: "",
    animationData: animation,

    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  }
  return (
    <>
      <RowPortada className="row">
        <Col xl={6} lg={6} md={12}>
          <ImgDiv>
            <Image fluid={props.fluidImgLogo} alt={props.altLogo}></Image>
          </ImgDiv>
          <TitleTwo>{Parser(props.title)}</TitleTwo>
          <RowDate>
            <p style={{ color: props.colorSpeaker }}>{props.date}</p>
          </RowDate>

          <SubTitleTwo>{Parser(props.subTitle)}</SubTitleTwo>

          <RowBtn className="row">
            {props.webinar === "true" && (
              <BtnGo href="#section-inscription">Ver webinar</BtnGo>
            )}

            {props.webinar === "false" && (
              <Inscription
                linkVideo={props.linkVideo}
                idMail={props.idMail}
                templateId={props.templateId}
                text={props.text}
                colorInput={props.colorInput}
                btnInputColor={props.btnInputColor}
                btnBorder={props.btnBorder}
                btnBorderRadius={props.btnBorderRadius}
              ></Inscription>
            )}
          </RowBtn>
          <RowOrganiza
            style={{ paddingTop: "2rem", marginTop: "2rem" }}
            className="row"
          >
            {props.invitation ? (
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "space-between",
                  maxWidth: "50%",
                }}
              >
                <p>Este taller es dictado por </p>
                <p>Invitan </p>
              </div>
            ) : (
              <p>Invitan</p>
            )}
            {/* <p>Te invita</p> */}
          </RowOrganiza>
          {props.altCompanyOne ? (
            <Row style={{ marginBottom: "2rem" }}>
              <ColImgLogos className="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-6 ">
                <Image fluid={props.logoClever} alt="CleverIT Group"></Image>
              </ColImgLogos>

              <ColImgLogos className="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-6 ">
                <Image
                  fluid={props.logoCompanyOne}
                  alt="CleverIT Group"
                ></Image>
              </ColImgLogos>
            </Row>
          ) : (
            <Row
              style={{ marginBottom: "2rem" }}
              className="justify-content-start"
            >
              <ColImgLogos className="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-12 ">
                <Image
                  fluid={props.logoClever}
                  alt="CleverIT Group"
                  style={{
                    maxWidth: "200px",
                    marginLeft: "auto",
                    marginRight: "auto",
                  }}
                ></Image>
              </ColImgLogos>
            </Row>
          )}
        </Col>
        <Col
          className=""
          xl={6}
          lg={6}
          md={8}
          sm={12}
          xs={12}
          style={{
            marginLeft: "auto",
            marginRight: "auto",
          }}
        >
          {/* <Image fluid={props.fluid} alt={props.alt}></Image> */}
          <Lottie
            options={defaultOptions}
            width={"100%"}
            height={"auto"}
            className=""
          />
          {/*  <div
            style={{ width: "1067px", height: "600px" }}
            className="lottie"
            data-animation-path={`../../../meets/anim/${props.anim}`}
            data-anim-loop="true"
            data-name="ninja"
          ></div> */}
          {console.log(props.anim)}
        </Col>
      </RowPortada>
    </>
  )
}

export default ImgPortada
const RowPortada = styled.div`
  max-width: 1280px;
  margin-left: auto;
  margin-right: auto;
  width: 100%;
  padding-top: 2rem;
  @media (max-width: 1280px) {
    padding-left: 3rem;
    padding-right: 3rem;
  }
  @media (max-width: 600px) {
    padding-left: 2rem;
    padding-right: 2rem;
  }
`

const ImgDiv = styled.div`
  width: 15rem;
  @media (max-width: 900px) {
    width: 15rem;
  }

  @media (max-width: 400px) {
    width: 10rem;
  }
`

const TitleTwo = styled.h2`
  font-family: "Inter", system-ui;
  font-weight: bold;
  line-height: 1.3;
  padding-top: 2rem;
  /* padding-bottom: 3rem; */
  font-size: 3rem;
  text-align: left;
  /* margin-top: 2rem; */

  @media (max-width: 900px) {
    /*  padding-left: 3rem;
    padding-right: 3rem; */
  }
  @media (max-width: 600px) {
    font-size: 2rem;
    padding-bottom: 2rem;
    /* padding-left: 2rem;
    padding-right: 2rem; */
  }
  @media (max-width: 400px) {
    font-size: 1.3rem;

    padding-bottom: 1rem;
  }
`

const SubTitleTwo = styled.h4`
  font-family: "Inter", system-ui;
  text-align: left;
  font-size: 1.125rem;
  padding-bottom: 2rem;
  padding-top: 2rem;
  line-height: 1.8rem;
  /* margin-bottom: 4rem;
  padding-left: 5rem;
  padding-right: 5rem; */

  @media (max-width: 900px) {
    /* padding-left: 3rem;
    padding-right: 3rem; */
  }
  @media (max-width: 600px) {
    font-size: 1rem;
    /*  padding-left: 2rem;
    padding-right: 2rem; */
  }
`

const BtnGo = styled.a`
  background-color: #9bf26d !important;
  padding: 1rem 2rem 1rem 2rem;
  border-radius: 6px;
  border-width: 0;
  /*  margin-left: auto;
  margin-right: auto; */
  text-decoration: none;
  color: black;
  font-size: 1.3rem !important;
  :active {
    background-color: #9bf26d !important;
  }
  :hover {
    background-color: #9bf26d !important;
    text-decoration: none;
  }
  :visited {
    background-color: #9bf26d !important;
  }
  :link {
    background-color: #9bf26d !important;
  }
  @media (max-width: 900px) {
    margin-left: auto;
    margin-right: auto;
  }
`
const RowBtn = styled.div`
  @media (max-width: 992px) {
    justify-content: center;
  }
`
const RowOrganiza = styled.div`
  @media (max-width: 992px) {
    justify-content: center;
  }
`
const RowDate = styled.div`
  p {
    color: #2db1d7;
    font-size: 1.6rem;
    font-weight: bold;
  }
  @media (max-width: 500px) {
    p {
      font-size: 1.2rem;
    }
  }
`
const ColImgLogos = styled.div`
  padding-left: 0;
  padding-right: 3rem;
  @media (max-width: 992px) {
    padding-left: 1rem;
    padding-right: 1rem;
  }
`
